import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {HttpProvider} from "../http/http";
import {global} from "../../environments/global";
import {Observable} from "rxjs/Rx";

/*
  Generated class for the StaffProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class StaffProvider {

  constructor(public http: HttpProvider) {
    console.log('Hello StaffProvider Provider');
  }

  getRoleList(page,pagesize){
    let params = {
      page:page,
      pagesize:pagesize
    };

    return this.http.hPost('/staff/get_role_list',params);
  }

  getStaffList(page,pagesize){
    let params = {
      page:page,
      pagesize:pagesize
    };

    return this.http.hPost('/staff/get_list',params);
  }

  all_modules;
  getAllMenu(){
    return this.all_modules?Observable.of(this.all_modules):this.getAvailableModules();
  }

  getAvailableModules(){
    return this.http.hPost('/staff/get_available_modules',{app_name:global.app_name_real}).map(res => {this.all_modules = res['content']['modules'];return this.all_modules});
  }


  deleteRole(id,page,pagesize){
    let params = {
      role_id:id,
      page:page,
      pagesize:pagesize
    };
    return this.http.hPost('/staff/delete_role',params);
  }

  createStaff(staff){
    return this.http.hPost('/staff/operate',staff);
  }

  deleteStaff(id,page,pagesize){
    let params = {
      staff_id:id,
      page:page,
      pagesize:pagesize
    };
    return this.http.hPost('/staff/delete',params);
  }

  saveRole(role){
    return this.http.hPost('/staff/set_role',role);
  }



}



// WEBPACK FOOTER //
// ./src/providers/staff/staff.ts